import { queryOptions } from "@tanstack/react-query";
import { getPerson } from "./getPerson";
import type { PersonDetails } from "./types";

export const getPersonOptions = (personDetails: PersonDetails) =>
    queryOptions({
        queryKey: ["selectedPerson", personDetails],
        queryFn: () => getPerson(personDetails),
    });
